import * as React from "react";
import { forwardRef } from "react";
const SvgLogoOpsgenie = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	preserveAspectRatio: "xMidYMid",
	viewBox: "-24.5 0 305 305",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
	id: "a",
	x1: "50%",
	x2: "50%",
	y1: "16.62%",
	y2: "119.2825%"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: "0%",
	stopColor: "#2684FF"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: "82%",
	stopColor: "#0052CC"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "b",
	x1: "41.1797%",
	x2: "67.7137%",
	y1: "31.1603%",
	y2: "78.6784%"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: "0%",
	stopColor: "#2684FF"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: "62%",
	stopColor: "#0052CC"
}))), /* @__PURE__ */ React.createElement("circle", {
	cx: 127.9961,
	cy: 76.0579,
	fill: "url(#a)",
	r: 76.0579
}), /* @__PURE__ */ React.createElement("path", {
	d: "M121.5158 302.9527A366.9027 366.9027 0 0 1 1.0766 177.0563a8.5267 8.5267 0 0 1 3.709-11.8094l57.5977-28.266c4.029-1.9646 8.8913-.4742 11.1273 3.4108a284.7482 284.7482 0 0 0 123.6368 111.9125 368.7786 368.7786 0 0 1-62.671 50.6485c-3.9655 2.4759-8.9952 2.4759-12.9606 0Z",
	fill: "url(#b)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M134.4763 302.9527a366.6469 366.6469 0 0 0 120.4393-125.8964 8.5267 8.5267 0 0 0-3.6665-11.8094l-57.6403-28.266c-4.029-1.9646-8.8913-.4742-11.1273 3.4108A284.6203 284.6203 0 0 1 58.8448 252.3042a366.647 366.647 0 0 0 62.671 50.6485c3.9654 2.4759 8.9951 2.4759 12.9605 0Z",
	fill: "#2684FF"
}));
const ForwardRef = forwardRef(SvgLogoOpsgenie);
export default ForwardRef;
